import React from 'react';

import { Modal } from 'antd';

export const showCmiDigestSelectionRequiredModal = (options: { includeFrequency?: boolean } = {}) => {
  const message = options.includeFrequency
    ? 'You need to select a Frequency, at least one Community, and at least one Content Included option.'
    : 'You need to select at least one Community and at least one Content Included option.';

  Modal.info({
    title: <div style={{ fontFamily: 'var(--font-regular)' }}>Selection Required</div>,
    content: <div style={{ fontFamily: 'var(--font-regular)' }}>{message}</div>,
    okText: 'OK',
    centered: true,
  });
};
